<template>
   <b-container>
    <b-card>
      <h4 slot="header">Additional Factors</h4>
      <b-form>
        <!--<rx-radio-->
          <!--v-model="chipCapeSealQ1"-->
          <!--:options="yesNoOptions"-->
          <!--title-text="Chip/Cape Seal Q1"-->
          <!--description="This is an optional question for the Chip / Cape Seal rehabilitation option. Responses to these questions may result in RxPave providing additional considerations in the final report."-->
          <!--id="chipCapeSealQ1"-->
        <!--&gt;</rx-radio>-->

        <!--<rx-radio-->
          <!--v-model="chipCapeSealQ2"-->
          <!--:options="yesNoOptions"-->
          <!--title-text="Chip/Cape Seal Q2"-->
          <!--description="This is an optional question for the Chip / Cape Seal rehabilitation option. Responses to these questions may result in RxPave providing additional considerations in the final report."-->
          <!--id="chipCapeSealQ2"-->
        <!--&gt;</rx-radio>-->

        <!--<rx-radio-->
          <!--v-model="overlayQ1"-->
          <!--:options="yesNoOptions"-->
          <!--title-text="Overlay Q1"-->
          <!--description="This is an optional question for the Chip / Cape Seal rehabilitation option. Responses to these questions may result in RxPave providing additional considerations in the final report."-->
          <!--id="chipCapeSealQ1"-->
        <!--&gt;</rx-radio>-->

        <!--<rx-radio-->
          <!--v-model="reconstructionQ1"-->
          <!--:options="yesNoOptions"-->
          <!--title-text="Reconstruction Q1"-->
          <!--description="This is an optional question for the Chip / Cape Seal rehabilitation option. Responses to these questions may result in RxPave providing additional considerations in the final report."-->
          <!--id="reconstructionQ1"-->
        <!--&gt;</rx-radio>-->

        <rx-radio
          v-model="isWheelPathFlushing"
          :options="yesNoOptions"
          title-text="Wheelpath Bleeding/Flushing"
          description="<strong>Is there moderate bleeding or flushing in the wheelpaths?</strong> Bleeding / flushing is the result of excessive asphalt binder accumulation on a pavement surface during construction that causes it to become shiny, reflective, and sticky. Additional information can be found at
<a href='https://www.pavementinteractive.org/reference-desk/pavement-management/pavement-distresses/bleeding/' target='_blank'> PavementInteractive</a> or <a href='https://rxpave.com/rxpave-resources/pavement-distress-profiles/' target='_blank'>RxPave</a>."
          id="isWheelPathFlushing"
          :validation="$v.isWheelPathFlushing"
        ></rx-radio>

        <rx-radio
          v-model="requireSmoothMacrotexture"
          :options="yesNoOptions"
          title-text="Macrotexture"
          description="<strong>Is there a desire to provide a smooth macrotexture for bikes, PEDs, or aesthetics?</strong> Macrotexture refers to the overall pavement texture resulting from the aggregate particle gradation in pavement surface and can be considered both an aesthetic or functional feature. Additional construction considerations are necessary if such effect is desired. Additional information can be found at <a href='https://www.pavementinteractive.org/reference-desk/pavement-management/pavement-evaluation/skid-resistance/' target='_blank'> PavementInteractive</a>."
          id="requireSmoothMacrotexture"
          :validation="$v.requireSmoothMacroTexture"
        ></rx-radio>

        <rx-radio
          v-model="requireMaintainCurbReveal"
          :options="yesNoOptions"
          title-text="Curb Reveal"
          description="<strong>Is there a need to maintain curb reveal?</strong> The reveal refers to the visible curb above the surface. Additional considerations may be necessary if this reveal must be maintained in your project."
          id="requireMaintainCurbReveal"
          :validation="$v.requireMaintainCurbReveal"
        ></rx-radio>

        <rx-radio
          v-model="existingSubgradeCbrUnderThreshold"
          :options="yesNoOptions"
          title-text="Subgrade CBR < 8"
          description="<strong>Is existing subgrade CBR < 8?</strong> CBR, the California Bearing Ratio, is strength test that results in an index that characterizes subgrade quality. If a pavement subgrade CBR is too low, structural repairs to the subgrade are necessary before any surface treatment. Additional information can be at <a href='https://www.pavementinteractive.org/reference-desk/design/design-parameters/california-bearing-ratio/' target='_blank'> PavementInteractive</a>."
          id="existingSubgradeCbrUnderThreshold"
          :validation="$v.existingSubgradeCbrUnderThreshold"
        ></rx-radio>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
  import { mapFields } from "vuex-map-fields";

  import { mapMutations, mapActions } from 'vuex'
  // const { mapMutations } = createNamespacedHelpers('rx');

  import { validationMixin } from 'vuelidate';
  import { required, between} from 'vuelidate/lib/validators'
  import {isValidSection4} from "../../../js/validation/projectValidation";

  import RxRadio from "./inputComponents/RxRadio";


  export default {
    name: "Section4",
    components: {
      RxRadio
    },
    mixins: [
      validationMixin
    ],
    data: function() {
      return {
        yesNoOptions: [
          {text: 'Unsure', value: -1},
          {text: 'No', value: 0},
          {text: 'Yes', value: 1},
        ],
      }
    },
    computed: {
      ...mapFields('rx',[
        "currentProject",
        "currentProject.isWheelPathFlushing",
        "currentProject.requireSmoothMacrotexture",
        "currentProject.requireMaintainCurbReveal",
        "currentProject.existingSubgradeCbrUnderThreshold"
      ])
    },
    updated: function () {
      console.log("Section 4 field validators match store validation:",
        isValidSection4(this.currentProject) === !this.$v.$invalid);
      this.setValidSection({
        section: '4',
        value: !this.$v.$invalid
      });
      // this.setCardStyle();
    },
    methods: {
      ...mapMutations('rx',[
        'setValidSection',
        'setPageValidationState'
      ]),
      ...mapActions('rx',[
        'validateProjectState'
      ])
    },
    validations:{
      isWheelPathFlushing: {
      },
      requireSmoothMacroTexture: {
      },
      requireMaintainCurbReveal: {
      },
      existingSubgradeCbrUnderThreshold: {
      }
    },
    beforeMount() {
      this.validateProjectState();
      this.setPageValidationState(this.$v);
    }
  }
</script>

<style scoped>

</style>